import React, { useEffect, useState, useMemo } from 'react';
import styles from './index.module.less';
import { Breadcrumb, Button, Col, Row, Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
// EditOutlined,
import CustomLayout from '@/common/Layout/index';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import emptyState from '../../../admin-doa-envelope/images/empty.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from '@/common/Content/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  // getActivityId,
  getAlldelegations,
  editDelegationId,
  getAllApprovers,
  getAllEnvelopes,
  deletedelegationItem
} from '../../redux/slice';
// getCategoryById
// import Pencil from '@/pages/initiate-envelope/images/Pencilsvg';
import AddModal from './AddModal';
import EditModal from './EditModal';
import ViewModal from './ViewModal';
// import { getAllCategories } from '@/pages/dashboard/redux/slice';

const Categories = () => {
  const {
    // get_activity,
    // pagination,
    getActivityDetails,
    getAllApproverLoading,
    allApprovers
    // allDelegations
  } = useSelector((state) => state.adminsettings);
  const {
    allDelegations,
    editDelegationDetails,
    allPendingEnvelopes,
    delegation_pagination
  } = useSelector((state) => state.settings);
  // const { category_by_id, byIdLoading } = useSelector(
  //   (state) => state.settings
  // );
  console.log('allPendingEnvelopes', allPendingEnvelopes);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id, setId] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [approverSearch, setApproverSearch] = useState('');
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [delegatorId, setDelegatorId] = useState(null);
  const [delegateId, setDelegateId] = useState(null); // State for delegate ID
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // View Modal
  const showViewModal = (id) => {
    let payload = {
      id: id,
      user: 'admin'
    };
    console.log('View ID:', payload);
    setId(id); // <-- Add this line
    dispatch(editDelegationId(payload));
    setIsViewModalOpen(true);
  };

  const handleViewOk = () => {
    setIsViewModalOpen(false);
  };
  const handleViewCancel = () => {
    setIsViewModalOpen(false);
  };

  // Show Edit Modal
  // const showEditModal = (id) => {
  //   let payload = {
  //     id: id
  //     // user: 'admin'
  //   };
  //   dispatch(editDelegationId(payload));
  //   setIsEditModalOpen(true);
  // };

  // Delete Modal
  const handleDelete = (id) => {
    console.log('handleDelete_payload', id);
    setSelectedDeleteId(id);
    setIsDeleteModalVisible(true); // Show the modal
  };

  const handleEditOk = () => {
    setIsEditModalOpen(false);
  };
  const handleEditCancel = () => {
    setIsEditModalOpen(false);
  };

  // console.log('allApprovers', allApprovers);
  const dispatch = useDispatch();
  const approverPayload = useMemo(() => {
    return { type: 'approvers', search: approverSearch };
    // return { type: 'users', search: approverSearch };
  }, [approverSearch]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(getAllApprovers(approverPayload));
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [dispatch, approverPayload]);

  console.log('delegatorId', delegatorId);
  console.log('delegateId', delegateId);

  useEffect(() => {
    if (delegatorId || delegateId) {
      handleGetenvelopes(delegatorId, delegateId);
    }
  }, [delegatorId, delegateId]);

  const handleDelegatorChange = (id) => {
    console.log('Delegator changed in child:', id);
    setDelegatorId(id);
    handleGetenvelopes(id, delegateId);
  };

  const handleDelegateChange = (id) => {
    console.log('Delegate changed in child:', id);
    setDelegateId(id);
    handleGetenvelopes(delegatorId, id);
  };

  const handleGetenvelopes = (
    customDelegatorId = delegatorId,
    customDelegateId = delegateId
  ) => {
    let payload = {
      search: search,
      page: page,
      delegator_id: customDelegatorId, // Checked with Bheema BE Team
      delegate_id: customDelegateId || '', // Checked with Bheema BE Team
      user: 'admin' // Add the user property here
    };
    if (search === '') {
      delete payload.search; // Remove `search` if it's not needed
    }
    if (customDelegatorId || customDelegateId) {
      dispatch(getAllEnvelopes(payload));
    }
  };

  const handleGetActivity = () => {
    let payload = {
      search: search,
      page: page
      // user: 'admin' // Add the user property here
    };
    if (search === '') {
      delete payload.search; // Remove `search` if it's not needed
    }
    dispatch(getAlldelegations(payload));
  };

  useEffect(() => {
    handleGetActivity();
  }, [search, page]);
  useEffect(() => {
    handleGetActivity();
  }, []);

  useEffect(() => {
    handleGetenvelopes();
  }, [search, page]);
  useEffect(() => {
    handleGetenvelopes();
  }, []);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // const data = get_activity;
  const data = allDelegations;
  const columns = [
    {
      title: 'Assigned Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(date).toLocaleDateString('en-GB', options); // Outputs: 01 Aug 2025
      }
    },
    {
      title: 'From Approver',
      key: 'delegator.email',
      render: (_, record) => record?.delegator?.email || 'N/A' // access nested field
    },
    {
      title: 'To Approver',
      key: 'delegate.email',
      render: (_, record) => record?.delegate?.email || 'N/A' // access nested field
    },
    // {
    //   title: 'Type',
    //   key: 'type',
    //   render: (_, record) => record?.type || 'N/A' // access nested field
    // },
    {
      title: 'Stock Data',
      key: 'stockData',
      render: (_, record) => {
        // const hasStock =
        //   record.type === 'stock' && record.envelope_approvers?.length > 0;
        // const count = record.envelope_approvers?.length || 0;
        const approvers = record.envelope_approvers || [];

        // Use a Set to remove duplicates based on an identifier (e.g., id or email)
        const uniqueApprovers = Array.isArray(approvers)
          ? Array.from(
              new Map(
                approvers.map((item) => [item?.envelope_id || item, item]) // replace 'id' with unique key if different
              ).values()
            )
          : [];

        const hasStock = record.type === 'stock' && uniqueApprovers.length > 0;
        const count = uniqueApprovers.length;
        return (
          <>
            {hasStock ? (
              <>
                <span style={{ marginRight: 8 }}>Yes</span>
                <span
                  style={{
                    backgroundColor: '#dbeafe', // Light blue
                    color: '#2563eb', // Darker blue text
                    borderRadius: '9999px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}
                >
                  {String(count).padStart(2, '0')}
                </span>
              </>
            ) : (
              'No'
            )}
          </>
        );
      }
    },
    // {
    //   align: 'center',
    //   width: '20%',
    //   title: 'Action',
    //   dataIndex: 'id',
    //   key: 'id',
    //   render: (id) => (
    //     <Tooltip title="Edit">
    //       <span
    //         className="cursor-pointer"
    //         onClick={() => {
    //           showEditModal(id);
    //         }}
    //       >
    //         <Pencil />
    //       </span>
    //     </Tooltip>
    //   )
    // }
    {
      align: 'center',
      width: '20%',
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => (
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Tooltip title="View">
            <span className="cursor-pointer" onClick={() => showViewModal(id)}>
              <EyeOutlined />
            </span>
          </Tooltip>

          {/* <Tooltip title="Edit">
            <span className="cursor-pointer" onClick={() => showEditModal(id)}>
              <EditOutlined />
            </span>
          </Tooltip> */}

          {/* <Tooltip title="Delete">
            <span className="cursor-pointer" onClick={() => handleDelete(id)}>
              <DeleteOutlined />
            </span>
          </Tooltip> */}
          <Tooltip title={record.deletable ? 'Delete' : 'Delete Disabled'}>
            <span
              className={`cursor-pointer ${
                !record.deletable ? 'disabled-icon' : ''
              }`}
              onClick={() => {
                if (record.deletable) {
                  handleDelete(id);
                }
              }}
              style={{
                color: record.deletable ? 'inherit' : '#ccc',
                pointerEvents: record.deletable ? 'auto' : 'none'
              }}
            >
              <DeleteOutlined />
            </span>
          </Tooltip>
        </div>
      )
    }
  ];

  return (
    <CustomLayout sider={false}>
      {' '}
      <div className={`${styles.breadcrub_container}`}>
        {' '}
        <Row>
          <Col span={19}>
            <Breadcrumb separator={<RightOutlined />}>
              <Breadcrumb.Item href="/settings">Settings</Breadcrumb.Item>

              <Breadcrumb.Item
                className="sfprotext-medium font-14"
                href="/settings/delegation-management"
              >
                Manage delegation
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col className="text-right" span={4}>
            <Button
              onClick={showModal}
              className="font-14 sfprotext-bold "
              type="primary"
            >
              + Set up Delegation
            </Button>
          </Col>
        </Row>
      </div>
      <Row>
        <Col span={18}>
          <div className="mt-3 font-16 sfprotext-bold">Delegation</div>
        </Col>
        <Col span={6}>
          <SearchBar
            onChange={handleSearchChange}
            className={`mt-3 ${styles.createdSearch}`}
            inputProps={{
              placeholder: 'Search'
            }}
          />
        </Col>
      </Row>
      {data?.length === undefined ? (
        <>
          <div className="df-jc-ac mt-5">
            <img src={emptyState} />
          </div>
          <div className="df-jc-ac mt-3">
            <div className="sfprotext-regular font-14">
              You haven’t created any activity yet.
            </div>
          </div>
          <div className="df-jc-ac mt-3">
            <Button
              onClick={showModal}
              type="primary"
              className="sfprotext-bold font-14"
            >
              + Set up Delegation
            </Button>
          </div>
        </>
      ) : (
        <CustomTable
          //loading={tableLoading}
          rowKey={(id) => id.id}
          className={`mt-4 ${styles.custom_table}`}
          /*  rowSelection={true} */
          dataSource={data}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setPage(page);
            },
            pageSize: 20,
            total: delegation_pagination?.total_records,
            showSizeChanger: false
          }}
        />
      )}
      <CustomModal
        visible={isDeleteModalVisible}
        onCancel={() => setIsDeleteModalVisible(false)}
        title="Confirm Deletion"
        footer={null}
        width={600}
        className="delegation-modal"
      >
        <p className="delegation-tabs">
          Are you sure you want to delete this delegation?
        </p>

        <div style={{ textAlign: 'right' }}>
          <CustomButton onClick={() => setIsDeleteModalVisible(false)}>
            No
          </CustomButton>
          <CustomButton
            type="primary"
            danger
            onClick={() => {
              const payload = {
                id: selectedDeleteId,
                user: 'user'
              };
              console.log('handleDelete_payload', payload);

              // Call your backend API here
              dispatch(deletedelegationItem(payload));
              setIsDeleteModalVisible(false); // Close modal after action
              handleGetActivity(); // Refresh the list
            }}
          >
            Yes
          </CustomButton>
        </div>
      </CustomModal>
      {isModalOpen ? (
        <AddModal
          // category_by_id={category_by_id?.[0]}
          getActivityId={getActivityDetails?.[0]}
          handleGetActivity={handleGetActivity}
          setIsModalOpen={setIsModalOpen}
          isModalVisible={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          setApproverSearch={setApproverSearch}
          getAllApproverLoading={getAllApproverLoading}
          allApprovers={allApprovers}
          allPendingEnvelopes={allPendingEnvelopes}
          onDelegatorChange={(delegatorId) => {
            console.log('Delegator changed:', delegatorId);
            setDelegatorId(delegatorId); // <-- Set it here
            handleGetenvelopes(delegatorId, delegateId);
            // 🟡 Optionally fetch new data based on this delegatorId
          }}
          onDelegateChange={(delegateId) => {
            console.log('Delegate changed:', delegateId);
            setDelegateId(delegateId); // <-- Set it here
            handleGetenvelopes(delegatorId, delegateId);
            // 🟡 Optionally fetch new data based on this delegateId
          }}
          // onDelegatorChange={onDelegatorChange}
        />
      ) : null}
      {isEditModalOpen ? (
        <EditModal
          // byIdLoading={byIdLoading}
          handleGetActivity={handleGetActivity}
          id={id}
          setId={setId}
          // category_by_id={category_by_id?.[0]}
          editDelegationDetails={editDelegationDetails?.[0]}
          getActivityId={getActivityDetails?.[0]}
          setIsEditModalOpen={setIsEditModalOpen}
          isEditModalVisible={isEditModalOpen}
          onOk={handleEditOk}
          onCancel={handleEditCancel}
          setApproverSearch={setApproverSearch}
          getAllApproverLoading={getAllApproverLoading}
          allApprovers={allApprovers}
          allPendingEnvelopes={allPendingEnvelopes}
          // onDelegatorChange={(delegatorId) => {
          //   console.log('Delegator changed:', delegatorId);
          //   setDelegatorId(delegatorId); // <-- Set it here
          //   handleGetenvelopes(delegatorId);
          //   // 🟡 Optionally fetch new data based on this delegatorId
          // }}
          onDelegatorChange={handleDelegatorChange}
          onDelegateChange={handleDelegateChange}
        />
      ) : null}
      {isViewModalOpen ? (
        <ViewModal
          // byIdLoading={byIdLoading}
          handleGetActivity={handleGetActivity}
          id={id}
          setId={setId}
          // category_by_id={category_by_id?.[0]}
          editDelegationDetails={editDelegationDetails?.[0]}
          getActivityId={getActivityDetails?.[0]}
          setIsViewModalOpen={setIsViewModalOpen}
          isViewModalVisible={isViewModalOpen}
          onOk={handleViewOk}
          onCancel={handleViewCancel}
          setApproverSearch={setApproverSearch}
          getAllApproverLoading={getAllApproverLoading}
          allApprovers={allApprovers}
          allPendingEnvelopes={allPendingEnvelopes}
          onDelegatorChange={handleDelegatorChange}
          onDelegateChange={handleDelegateChange}
        />
      ) : null}
    </CustomLayout>
  );
};

export default Categories;
